import React from 'react';
import { useAuth } from '../hooks/useAuth';

const SettingsPage: React.FC = () => {
  const { agency, user } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Settings
          </h1>
          <p className="text-gray-600">
            Manage your agency settings and preferences
          </p>
        </div>

        <div className="space-y-8">
          {/* Agency Settings */}
          <div className="card">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Agency Information</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Agency Name
                </label>
                <input
                  type="text"
                  defaultValue={agency?.name}
                  className="input-field"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Custom Domain
                </label>
                <div className="flex">
                  <input
                    type="text"
                    defaultValue={agency?.domain}
                    className="input-field rounded-r-none"
                  />
                  <span className="bg-gray-50 border border-l-0 border-gray-300 rounded-r-lg px-3 py-3 text-gray-500 text-sm">
                    .bip.com
                  </span>
                </div>
              </div>
            </div>
            <div className="mt-6">
              <button className="btn-primary">
                Save Changes
              </button>
            </div>
          </div>

          {/* White Labeling */}
          <div className="card">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">White Labeling</h2>
            <p className="text-gray-600 mb-6">
              Customize how your clients see their portals
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Logo URL
                </label>
                <input
                  type="url"
                  className="input-field"
                  placeholder="https://example.com/logo.png"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Brand Color
                </label>
                <input
                  type="color"
                  defaultValue="#3b82f6"
                  className="input-field h-12"
                />
              </div>
            </div>
          </div>

          {/* API Settings */}
          <div className="card">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">API Configuration</h2>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  API Key
                </label>
                <div className="flex">
                  <input
                    type="text"
                    value="bip_••••••••••••••••••••••••••••••••"
                    readOnly
                    className="input-field rounded-r-none bg-gray-50"
                  />
                  <button className="bg-gray-200 hover:bg-gray-300 px-4 py-3 rounded-r-lg border border-l-0 border-gray-300 text-sm font-medium">
                    Regenerate
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
